import React, { Component } from 'react';
import { Row, Col, Table, PanelGroup, Panel, Popover, OverlayTrigger } from "react-bootstrap";
import { CustomCard } from "../../../components/Card/CustomCard";
import { toast } from 'react-toastify';

import { BusquedaEstInd, CheckStatusDelT, DelTrasaccion, FixEstadoInd, DownloadXls } from "../../../funciones/CobranzasFunction";
import { ConsultCuentaAdmin, ConsultaDeudaEst2 } from "../../../funciones/EstCuentaFunction";
import { formatNumber, formatReconver } from "../../../funciones/GeneralFunctions";

import EstCuentaTable from "./EstCuentaTable";
import EditarAsiento from "./EditarAsiento";

import CustomModal from "../../../components/Modal/CustomModal";
import ModalReports from '../../../components/Reportes/ModalReports';
import EstadoDeCuentaRpt from '../../../components/Reportes/EstadoDeCuentaRpt';
import DatosInscripcion from "../../Inscripcion/DatosInscripcion";

let detalleEst = "";
let detalleEstHIst = [];
let idEstudiante = "";
let UserState = "";
let idDel = "";
let idAsient = "";
class Cuentas extends Component {
    state = {
        string: "",
        icon2: "",
        listEst: [],
        preloaderI:{
            icon: "",
            text: "Ingresa la Cédula, el nombre o el apellido del estudiante para buscar"
        },
        control:false,
        openWR: false,
        botonDel: {
            icon: "fa fa-trash",
            text: "Eliminar",
            disabled: false
        },
        botonEdit: {
            icon: "fa fa-edit",
            text: "Editar",
            disabled: false
        },
        status: "",
        openDel: false,
        openconfirm: false,
        openconfirm2: false,
        openDelBtn1: {
            icon:"fa fa-check",
            text: "Si",
            disabled: false
        },
        openEditBtn1: {
            icon:"fa fa-save",
            text: "Guardar",
            disabled: true
        },
        openEdit: false,
        estados: false,
        estadosHist: false,
        iconChevron2: "fa fa-chevron-down",
        btnDown2: true,
        iconChevron3: "fa fa-chevron-down",
        btnDown3: true,
        FixBtn1: {
            icon:"fa fa-cog",
            text: "Reparar Estado",
            disabled: false
        },
        deudaT: "",
        descargarBtn: {
            icon:"fa fa-download",
            text: "Descargar",
            disabled: false
        },
    }

    componentDidMount = () => {
        CheckStatusDelT ((resp) => {
            UserState = resp
            this.setState({ status: resp })
        })
    }

    cambiaValor = (prop) => (e) => {
        this.setState({
            [prop]: e.target.value
        })
    }

    cambiaIcon = (btn, icon, content) => {
        this.setState ({
            [btn]: !this.state[btn],
            [content]:!this.state[content],
        }, () => {
            (this.state[btn] === true) ? this.setState({[icon]: "fa fa-chevron-down"}) : this.setState({[icon]: "fa fa-chevron-up"})
        })
    }

    busquedaEst = () => (e) => {
        if (e.which === 13){
            if (this.state.string === "") return null;
            detalleEst = ""
            this.setState ({
                icon2: "fa fa-spinner fa-spin",
                preloaderI:{
                    icon: "fa fa-spinner fa-spin",
                    text: "Buscando estudiantes, espera"
                },
                listEst: []
            }, () => {
                BusquedaEstInd (this.state.string, (resp) => {
                    let prel = { icon: "", text: "" };
                    if (resp.length === 0) prel = { icon: "", text: "No existen coincidencias con la búsqueda seleccionada" };

                    this.setState({
                        listEst: resp,
                        icon2: "",
                        preloaderI: prel,
                    })

                })
            })
        }
    }

    descargaExcel = (tipo) => {
        if (this.state.descargarBtn.disabled === true) return null;

            this.setState ({
                openconfirm: false,
                openconfirm2: false,
                descargarBtn: {
                    icon:"fa fa-spinner fa-spin",
                    text: "Descargar",
                    disabled: true
                }
            }, () => {
                DownloadXls (tipo, (resp) => {
                    this.setState ({
                        descargarBtn: {
                            icon:"fa fa-download",
                            text: "Descargar",
                            disabled: false
                        }
                    });
                })
            })
    }

    modalDel = () => {
        const { openDel, openDelBtn1 } = this.state;
        
        let contenido = () => (
            <React.Fragment>
                <div>Esta función es delicada y puede ocacionar <strong className="text-danger">FALLAS AL SISTEMA</strong> si no se maneja con precaución. Al confirmar asumes la responsabildad de la transacción.</div><div align = "center"><strong>¿Deseas <span className="text-danger">Eliminar</span> este asiento?</strong></div>
                <div style={{fontSize: 12, padding: 5}} className="custom-alert-danger" align="center"><i className="fa fa-exclamation-triangle"></i> <strong>Esta opción no puede deshacerse</strong></div>
            </React.Fragment>
        )

        let Del = () => {
            if (openDelBtn1.disabled === true) return null;

            this.setState({
                openDelBtn1: {
                    icon:"fa fa-spinner fa-spin",
                    text: "Espera",
                    disabled: true
                },
                botonDel: {
                    icon: "fa fa-spinner fa-spin",
                    text: "Espera",
                    disabled: true
                }
            }, () => {
                DelTrasaccion(idDel, (resp1) => {
                    toast[resp1.status](resp1.mess, {autoClose: 4000});
                    ConsultCuentaAdmin (idEstudiante, (resp2) => {
                        idDel = ""
                        let det = detalleEst
                        detalleEst = [resp2, det];
                        this.setState({
                            control: !this.state.control,
                            botonDel: {
                                icon: "fa fa-trash",
                                text: "Eliminar",
                                disabled: false
                            },
                            openDel: false,
                            openDelBtn1: {
                                icon:"fa fa-check",
                                text: "Si",
                                disabled: false
                            }
                        })
                    })
                })
            })
        }

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> No</React.Fragment>}
                boton1 = {<React.Fragment><i className={openDelBtn1.icon}></i> {openDelBtn1.text}</React.Fragment>}
                large = "medium"
                isopen =  {openDel}
                titulo = "Confirmación"
                contenido = {contenido()}      
                funcion1 = {() => {Del()}}
                funcion2 = {() => {this.setState({openDel: false})}}
            />
        );
    }

    modalConfirm = () => {
        const { openconfirm } = this.state;

        let contenido = () => (
            <React.Fragment>
                <div>Esta función permite descargar los estados de cuenta de todos los estudiantes en un libro en formato <strong className = 'text-success'>.xls</strong> por lo tanto puede tardar en procesarse todo el listado.</div>
                <div style={{fontSize: 12, padding: 5}} className="custom-alert-danger" align="center"><i className="fa fa-exclamation-triangle"></i> <strong>Esta función puede tardar varios minutos</strong></div>
                <div className = 'custom-mt-10' align = "right"><strong>¿Deseas continuar con la operación?</strong></div>
            </React.Fragment>
        )

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> No</React.Fragment>}
                boton1 = {<React.Fragment><i className="fa fa-check"></i> Si</React.Fragment>}
                large = "medium"
                isopen =  {openconfirm}
                titulo = "Confirmación"
                contenido = {contenido()}      
                funcion1 = {() => {this.descargaExcel("segmentado")}}
                funcion2 = {() => {this.setState({openconfirm: false})}}
            />
        );
    }

    modalConfirm2 = () => {
        const { openconfirm2 } = this.state;

        let contenido = () => (
            <React.Fragment>
                <div>Esta función permite descargar los estados de cuenta de todos los estudiantes en un libro en formato <strong className = 'text-success'>.xls</strong> <strong>(SIN FORMATO)</strong> por lo tanto puede tardar en procesarse todo el listado.</div>
                <div style={{fontSize: 12, padding: 5}} className="custom-alert-danger" align="center"><i className="fa fa-exclamation-triangle"></i> <strong>Esta función puede tardar varios minutos</strong></div>
                <div className = 'custom-mt-10' align = "right"><strong>¿Deseas continuar con la operación?</strong></div>
            </React.Fragment>
        )

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> No</React.Fragment>}
                boton1 = {<React.Fragment><i className="fa fa-check"></i> Si</React.Fragment>}
                large = "medium"
                isopen =  {openconfirm2}
                titulo = "Confirmación"
                contenido = {contenido()}      
                funcion1 = {() => {this.descargaExcel("sin_formato")}}
                funcion2 = {() => {this.setState({openconfirm2: false})}}
            />
        );
    }

    modalEdit = () => {
        let { openEdit } = this.state;

        if  (idAsient === "") return null;

        let contenido = () => (
            <Row>
                <Col md = {12}>
                    <EditarAsiento id = {idAsient}
                    funcionOk = {(valor) => {
                        this.setState({
                            openEdit: valor
                        }, () => {
                            ConsultCuentaAdmin (idEstudiante, (resp2) => {
                                idDel = ""
                                let det = detalleEst
                                detalleEst = [resp2, det];
                                this.setState({
                                    control: !this.state.control,
                                    botonDel: {
                                        icon: "fa fa-trash",
                                        text: "Eliminar",
                                        disabled: false
                                    },
                                    openDel: false,
                                    openDelBtn1: {
                                        icon:"fa fa-check",
                                        text: "Si",
                                        disabled: false
                                    }
                                })
                            })
                        })
                    }}
                    />
                </Col>
            </Row>
        )

        return(
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> Cancelar</React.Fragment>}
                boton1 = ""
                large = "medium"
                isopen =  {openEdit}
                titulo = "Editar Estado de Cuenta"
                contenido = {contenido()}
                funcion2 = {() => {this.setState({openEdit: false})}}
            />
        )
    }

    contenido = () => {
        let { string, icon2, listEst, preloaderI, botonDel, botonEdit, estados, iconChevron2, estadosHist, iconChevron3, FixBtn1, deudaT,
            descargarBtn } = this.state;
        
        const styles = {
            padding: 5, fontSize: 12
        }

        const stylesBs = {
            padding: 3, fontSize: 10
        }

        let tablaEst = () => {
            if (listEst.length === 0) return (<div align="center" className="text-danger"><i className={preloaderI.icon}></i> {preloaderI.text}</div>)

            return (
                <div className="table-responsive" style={{overflowY: "auto", maxHeight: "25vh", backgroundColor: "#FFF", border: "1px solid #1f2f6e"}}>
                    <Table striped hover bordered>
                        <tbody>
                            <tr className="custon-back-color">
                                <td width="45%" style={styles}><strong>Estudiante</strong></td>
                                <td width="35%" align="center" style={styles}><strong>Carrera</strong></td>
                                <td width="20%" align="center" style={styles}><strong>Estado</strong></td>
                                <td width="200px" align="center" style={styles}><strong>Acciones</strong></td>
                            </tr>
                            {listEst.map (option => (
                                <EstCuentaTable key={option.id} datos={option}
                                    Detalles={(datos) => {
                                        detalleEst = datos;
                                        detalleEstHIst = datos[2];
                                        idEstudiante = option.id
                                        
                                        this.setState({
                                            control: !this.state.control
                                        }, () => {
                                            ConsultaDeudaEst2 (datos[1].Email, (resp) => {
                                                this.setState({deudaT: resp})
                                            })
                                        })
                                    }}
                                />
                            ))}
                        </tbody>
                    </Table>
                </div>
            )
        }

        let contentEstadoHist = () => {
            if (detalleEstHIst.length === 0) return (
                <tr>
                    <td colSpan={7} align="center">No existen asientos históricos disponibles</td>
                </tr>
            )

            let bs = (monto) => {
                let bs = `${formatNumber(monto)}`;
                let bsConv = `${formatReconver(monto)}`;

                if (monto === "" || monto === null) bs = "";
                
                return (
                    <React.Fragment>
                        <div>{bs}</div>
                        {/* <div className = "text-danger" style = {{fontWeight: "bold"}}>{bsConv}</div> */}
                    </React.Fragment>
                )
            }

            let icono = (mess, status) => {
                let icono = <i className="fa fa-check-circle text-success"></i>;
                if (status === "0") icono = <i className="fa fa-exclamation-triangle text-warning"></i>;
                if (mess === "Error") icono = <i className="fa fa-times-circle text-danger"></i>;

                return icono;
            }

            let status = (mess, status) => {
                let styles = {color:"#000"}
                if (status === "0") styles = {backgroundColor: "#f8f2ee", color:"#a80012", cursor:"pointer"}
                if (mess === "Error") styles = {backgroundColor: "#fff4f6", color:"#A0555C", cursor:"pointer"}

                return styles;
            }

            let aviso = (mess, status) => {
                let aviso = "";
                if (status === "0") aviso = "Esta transacción está pendiente de aprobación";
                if (mess === "Error") aviso = "Esta transacción presenta un problema. Ponte en contacto con Administración";

                return aviso;
            }

            let btnDel = (id, num, text) => {
                switch (UserState){
                    case "": return text;
                    case 0: return text;
                    case 1: return <React.Fragment>
                            {text}
                            {/* <div align="right">
                                <div className="btn-group">
                                    <button className="btn btn-warning btn-sm"  style={{borderWidth: 1}} onClick = {() => {
                                        idAsient = id;
                                        this.setState({
                                            openEdit: true})
                                        }}><i className={botonEdit.icon} title="Editar este asiento">
                                        </i> {botonEdit.text}
                                    </button>
                                    <button className="btn btn-danger btn-sm" style={{borderWidth: 1}} onClick = {() => {
                                        idDel = id;
                                        this.setState({
                                            openDel: true})
                                        }} title="Eliminar este asiento"><i className={botonDel.icon}>
                                        </i> {botonDel.text}
                                    </button>
                                </div>
                            </div> */}
                        </React.Fragment>
                    default: return text;
                }
            }

            let num = 0
            return (
                detalleEstHIst.map(option => {
                    num++;
                    return(
                        <tr key = {option.num} style={status(option.resultado, option.status)} title ={aviso(option.resultado, option.status)}>
                            <td align="center" style={{padding: 5, fontSize: 10}}>{option.num}</td>
                            <td align="center" style={{padding: 5, fontSize: 10}}>{option.fecha}</td>
                            <td style={{padding: 5, fontSize: 10}}>{btnDel(option.num, num, option.descripcion)}</td>
                            <td align="center" style={stylesBs}>{bs(option.debe)}</td>
                            <td align="center" style={stylesBs}>{bs(option.haber)}</td>
                            <td align="center" style={stylesBs}>
                                {formatNumber(option.saldo)}
                                {/* <div className = "text-danger" style = {{fontWeight: "bold"}}>{formatReconver(option.saldo)}</div> */}
                            </td>
                            <td align="center" style={styles}>{icono(option.resultado, option.status)}</td>
                        </tr>
                    )
                })
            )
        }

        let contentEstado = () => {
            if (detalleEst[0].length === 0) return (
                <tr>
                    <td colSpan={7} align="center">No existen asientos disponibles</td>
                </tr>
            )
            
            let bs = (monto) => {
                let bs = `${formatNumber(monto)}`;
                let bsConv = `${formatReconver(monto)}`;

                if (monto === "" || monto === null) bs = "";
                return (
                    <React.Fragment>
                        <div>{bs}</div>
                        {/* <div className = "text-danger" style = {{fontWeight: "bold"}}>{bsConv}</div> */}
                    </React.Fragment>
                )
            }

            let icono = (mess, status) => {
                let icono = <i className="fa fa-check-circle text-success"></i>;
                if (status === "0") icono = <i className="fa fa-exclamation-triangle text-warning"></i>;
                if (mess === "Error") icono = <i className="fa fa-times-circle text-danger"></i>;

                return icono;
            }

            let status = (mess, status) => {
                let styles = {color:"#000"}
                if (status === "0") styles = {backgroundColor: "#f8f2ee", color:"#a80012", cursor:"pointer"}
                if (mess === "Error") styles = {backgroundColor: "#fff4f6", color:"#A0555C", cursor:"pointer"}

                return styles;
            }

            let aviso = (mess, status) => {
                let aviso = "";
                if (status === "0") aviso = "Esta transacción está pendiente de aprobación";
                if (mess === "Error") aviso = "Esta transacción presenta un problema. Ponte en contacto con Administración";

                return aviso;
            }

            let num = 0
            let btnDel = (id, num, text) => {
                /* if (num === detalleEst[0].length){ */
                    switch (UserState){
                        case "": return text;
                        case 0: return text;
                        case 1: return <React.Fragment>
                                {text}
                                <div align="right">
                                    <div className="btn-group">
                                        <button className="btn btn-warning btn-sm"  style={{borderWidth: 1}} onClick = {() => {
                                            idAsient = id;
                                            this.setState({
                                                openEdit: true})
                                            }}><i className={botonEdit.icon} title="Editar este asiento">
                                            </i> {botonEdit.text}
                                        </button>
                                        <button className="btn btn-danger btn-sm" style={{borderWidth: 1}} onClick = {() => {
                                            idDel = id;
                                            this.setState({
                                                openDel: true})
                                            }} title="Eliminar este asiento"><i className={botonDel.icon}>
                                            </i> {botonDel.text}
                                        </button>
                                    </div>
                                </div>
                            </React.Fragment>
                        default: return text;
                    }
                /* }else{
                    return text; 
                } */
            };

            return (
                detalleEst[0].map(option => {
                    num++;
                    return(
                        <tr key = {option.num} style={status(option.resultado, option.status)} title ={aviso(option.resultado, option.status)}>
                            <td align="center" style={{padding: 5, fontSize: 10}}>{option.num}</td>
                            <td align="center" style={{padding: 5, fontSize: 10}}>{option.fecha}</td>
                            <td style={{padding: 1, fontSize: 10}}>{btnDel(option.num, num, option.descripcion)}</td>
                            <td align="center" style={stylesBs}>{bs(option.debe)}</td>
                            <td align="center" style={stylesBs}>{bs(option.haber)}</td>
                            <td align="center" style={stylesBs}>
                                {formatNumber(option.saldo)}
                                {/* <div className = "text-danger" style = {{fontWeight: "bold"}}>{formatReconver(option.saldo)}</div> */}
                            </td>
                            <td align="center" style={styles}>{icono(option.resultado, option.status)}</td>
                        </tr>
                    )
                })
            )
        }

        let histAsientos = () => {
            if (detalleEstHIst.length === 0) return null;

            return(
                <PanelGroup accordion activeKey={estadosHist} className="custom-alert-danger">
                    <Panel eventKey = {true}>
                        <Panel.Heading onClick = {()=> {this.cambiaIcon( "btnDown3", "iconChevron3", "estadosHist")}}>
                            <Panel.Title toggle className="text-danger">
                                <Row>
                                    <Col md={10} style={{fontSize: 12}}>
                                        <strong><i className="fa fa-calendar"></i> Histórico de Asientos</strong>
                                    </Col>
                                    <Col md={2} align="right">
                                        <i className={iconChevron3}></i>
                                    </Col>
                                </Row>
                            </Panel.Title>
                        </Panel.Heading>
                        <Panel.Body collapsible style={{paddingTop:10}}>
                            <div className="table-responsive" style={{overflowY: "auto", maxHeight:"45vh", backgroundColor: "#FFF", border: "1px solid #1f2f6e"}}>
                                <Table striped hover bordered style={{marginBottom: 0}}>
                                    <tbody>
                                        <tr className="custon-back-color">
                                            <td width="10%" align="center" style={styles}><strong>N°</strong></td>
                                            <td width="10%" align="center" style={styles}><strong>Fecha</strong></td>
                                            <td width="36%" style={styles}><strong>Descripción</strong></td>
                                            <td width="14%" align="center" style={stylesBs}><strong>Facturado</strong></td>
                                            <td width="14%" align="center" style={stylesBs}><strong>Pagado</strong></td>
                                            <td width="16%" align="center" style={stylesBs}><strong>Balance</strong></td>
                                            <td width="30px" align="center" style={styles}></td>
                                        </tr>
                                        {contentEstadoHist()}
                                    </tbody>
                                </Table>
                            </div>
                        </Panel.Body>
                    </Panel>
                </PanelGroup>
            )
        }

        let botonFix = () => {
            if (detalleEst[2] === undefined) return null

            switch (UserState){
                case "": return null;
                case 0: return null;
                case 1: return (
                    <div className = "custom-mt-10" align = "right"><button title = "Reparar Estado de Cuenta" onClick = {() => {
                        this.setState({
                            FixBtn1: {
                                icon:"fa fa-spinner fa-spin",
                                text: "Reparando Espera",
                                disabled: true
                            }
                        }, () => {
                            FixEstadoInd(detalleEst[1].id, () => {
                                this.setState({
                                    FixBtn1: {
                                        icon:"fa fa-spinner fa-spin",
                                        text: "Actualizando Estado",
                                        disabled: true
                                    }
                                }, () => {
                                    let det = detalleEst
                                    ConsultCuentaAdmin (detalleEst[1].id, (resp2) => {
                                        detalleEst = [resp2, det[1], det[2]];
                                        this.setState({
                                            control: !this.state.control,
                                            FixBtn1: {
                                                icon:"fa fa-cog",
                                                text: "Reparar Estado",
                                                disabled: false
                                            }
                                        }, () => {
                                            toast.info("Se ha reparado el estado de cuenta correctamente", {autoClose: 4000});
                                        })
                                    })
                                })
                            })
                        })
                    }} className = "btn btn-danger" style={{borderWidth: 1}} disabled = {FixBtn1.disabled}><i className = {FixBtn1.icon}></i>{FixBtn1.text}</button></div>
                )
                default: return null;
            }
        }

        let deudaDet = () => {
            let vencimiento = deudaT.vencimiento;
            if (vencimiento === undefined || vencimiento === null) return null;

            if (deudaT.info === "Actualmente no tienes deuda" || deudaT.totalGral === 0) return (
                <div className = "custom-alert-info custom-mt-10" style={{padding: 5}}>
                    <i className = "fa fa-check-circle text-success"></i>Este estudiante está solvente actualmente
                </div>
            )

            vencimiento = vencimiento.replace('Actualmente presentas un atraso en el pago', 'Este estudiante presenta un atraso en el pago');

            return(
                <div className = "custom-alert-danger custom-mt-10" style={{padding: 5}}>
                    <Row>
                        <Col md = {12}><strong className="text-danger">Detalles de la deuda:</strong></Col>
                        <Col md = {12}>
                            <div className="table-responsive" style={{backgroundColor: "#FFF", border:"1px solid #bf4747"}}>
                                <Table striped hover style={{marginBottom: 0}}>
                                    <tbody>
                                        <tr>
                                            <td width="50%" style={styles}>
                                                Deuda Pendiente
                                                <div style={{fontSize: 10}}><strong>Vence: {vencimiento}</strong></div>
                                            </td>
                                            <td width="50%" style={styles} align="right">
                                                {formatNumber(deudaT.deuda)} Bs.
                                                {/* <div className = "text-danger" style = {{fontWeight: "bold"}}>{formatReconver(deudaT.deuda)} Bs.</div> */}
                                            </td>
                                        </tr>
                                        {/* <tr>
                                            <td width="50%" style={styles}>Deuda Vencida</td>
                                            <td width="50%" style={styles} align="right">{formatNumber(deudaT.deudaVencida)} Bs.</td>
                                        </tr> */}
                                        <tr>
                                            <td width="50%" style={styles}>Intereses Deuda Vencida</td>
                                            <td width="50%" style={styles} align="right">
                                                {formatNumber(deudaT.interes)} Bs.
                                                {/* <div className = "text-danger" style = {{fontWeight: "bold"}}>{formatReconver(deudaT.interes)} Bs.</div> */}
                                            </td>
                                        </tr>
                                        <tr style = {{backgroundColor: "#a0555c", color: "#ffffff"}}>
                                            <td width="50%" style={styles}><strong style = {{fontSize: 16}}>TOTAL A PAGAR</strong></td>
                                            <td width="50%" style={styles} align="right">
                                                <strong style = {{fontSize: 16}}>{formatNumber(deudaT.totalGral)} Bs.</strong>
                                                {/* <div style = {{fontWeight: "bold"}}>{formatReconver(deudaT.totalGral)} Bs.</div> */}
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        </Col>
                    </Row>
                </div>
            )
        }
        let detalles = () => {
            if (listEst.length === 0) return null;
            if (detalleEst === "") return (<div className="text-danger custom-mt-10" align="center">Selecciona un Estudiante para revisar su Estado de Cuenta</div>)

            return (
                <React.Fragment>
                    <div className="custom-alert-info custom-mt-10" style={{padding: 5}}>
                        <Row>
                            <Col md={7}>
                                <div style={{marginTop: 10}}>Estado de Cuenta de <strong>{detalleEst[1].Estudiante}</strong></div>
                            </Col>
                            <Col md={5} align="right">
                                <button className="btn btn-relleno-primary" onClick={() => {this.setState({openWR: true})}} style={{borderWidth:1}} title={`Imprimir el estado de cuenta de ${detalleEst[1].Estudiante}`}><i className="fa fa-print"></i> Imprimir</button>
                            </Col>
                        </Row>
                    </div>
                    <div className="custom-mt-10">
                        <PanelGroup accordion activeKey={estados} className="custom-alert-info">
                            <Panel eventKey = {true}>
                                <Panel.Heading onClick = {()=> {this.cambiaIcon( "btnDown2", "iconChevron2", "estados")}}>
                                    <Panel.Title toggle className="custom-color">
                                        <Row>
                                            <Col md={10} style={{fontSize: 12}}>
                                                <strong>Materias Inscritas</strong>
                                            </Col>
                                            <Col md={2} align="right">
                                                <i className={iconChevron2}></i>
                                            </Col>
                                        </Row>
                                    </Panel.Title>
                                </Panel.Heading>
                                <Panel.Body collapsible style={{paddingLeft:5, paddingRight:5, paddingTop:10}}>
                                    <DatosInscripcion idEst={detalleEst[1].id }
                                    tlf = {detalleEst[1].Tlf} cel = {detalleEst[1].Cel}
                                    email = {detalleEst[1].Email} dir = {detalleEst[1].Dir}
                                    EstCuenta ={true}/>
                                </Panel.Body>
                            </Panel>
                        </PanelGroup>
                    </div>
                    <Row className="custom-mt-10">
                        <Col md={6}><span className="text-danger">Carrera:</span> <strong>{detalleEst[1].Carrera}</strong></Col>
                        <Col md={6} align="right"><span className="text-danger">Deuda:</span> <strong>{detalleEst[1].Deuda}</strong></Col>
                    </Row>
                    {histAsientos()}
                    <div className="table-responsive" style={{overflowY: "auto", maxHeight:"45vh", backgroundColor: "#FFF", border: "1px solid #1f2f6e"}}>
                        <Table striped hover bordered style={{marginBottom: 0}}>
                            <tbody>
                                <tr className="custon-back-color">
                                    <td width="10%" align="center" style={styles}><strong>N°</strong></td>
                                    <td width="10%" align="center" style={styles}><strong>Fecha</strong></td>
                                    <td width="36%" style={styles}><strong>Descripción</strong></td>
                                    <td width="14%" align="center" style={stylesBs}><strong>Facturado Bs-</strong></td>
                                    <td width="14%" align="center" style={stylesBs}><strong>Pagado Bs.</strong></td>
                                    <td width="16%" align="center" style={stylesBs}><strong>Balance Bs.</strong></td>
                                    <td width="30px" align="center" style={styles}></td>
                                </tr>
                                {contentEstado()}
                            </tbody>
                        </Table>
                    </div>
                    {deudaDet()}
                    {botonFix()}
                </React.Fragment>
            )
        }

        let menu = (
            <Popover bsSize="large" id="acciones">
                <div className="text-primary" style={{cursor:"pointer", fontSize: 12, padding: 5}} onClick = {() => this.setState({openconfirm: true})}>
                    Estados de Cuenta Segmentado
                </div>
                <div className="text-danger" style={{cursor:"pointer", fontSize: 12, padding: 5}} onClick = {() => this.setState({openconfirm2: true})}>
                    Estados de Cuenta Sin Formato
                </div>
            </Popover>
        );

        return (
            <React.Fragment>
                <Row>
                    <Col md={9} style={{fontSize: 12}}>
                        <div className="custom-alert-info">
                            Búsqueda de Estudiantes <i className={icon2}></i>
                            <input type="text" className="form-control" onKeyPress={this.busquedaEst()} value={string} onChange={this.cambiaValor("string")} placeholder="Ingresa la C.I., nombre o apellido del estudiante"/>
                        </div>
                    </Col>
                    <Col md={3} align="center">
                        <div style ={{fontSize: 9 }}>Descargar Estados de Cuenta</div>
                        <OverlayTrigger trigger="focus" placement="bottom" overlay={menu}>
                            <button className = 'btn btn-success' disabled = {descargarBtn.disabled} style={{borderWidth: 1}}> <i className = {descargarBtn.icon}></i> {descargarBtn.text} <i className = "fa fa-caret-down"></i></button>
                        </OverlayTrigger>
                    </Col>
                </Row>
                <div className="custom-mt-10">{tablaEst()}</div>
                <div className="custom-mt-10">{detalles()}</div>
            </React.Fragment>
        )
    }

    modalReporte = () => {
        let { openWR } = this.state;
        if (openWR === false ) return null;

        return (
            <ModalReports
                reporte={<EstadoDeCuentaRpt datos ={detalleEst}/>}
                titulo={`Estado de Cuenta del Estudiante`}
                display= "block"
                cerrar = {() => {this.setState({openWR: false})}}
            />
        )
    }

    ayuda = () => (
        <Row>
            <Col md={12} align="justify">
                En esta sección puedes revisar los <span className="text-primary"><strong>Estados de Cuenta</strong></span> de los estudiantes asi como tambíén crear un reporte para su impresión
            </Col>
            <Col md={12} className="custom-mt-10" align="justify">
                Para ello primero debes ingresar un dato del estudiante que deseas consultar (Cédula, Nombre o Apellido)
            </Col>
            <Col md={12} className="custom-mt-10" align="justify">
                Al realizar la consulta podrás ver un listado con las coincidencias.
            </Col>
            <Col md={12} className="custom-mt-10" align="justify">
                El botón <button className="btn btn-primary btn-xs" style={{borderWidth: 1}}><i className="fa fa-money"></i> Cuenta</button> ubicado al lado derecho de cada estudiante permite ver detalladamente el resumen de sus transacciones
            </Col>
            <Col md={12} className="custom-mt-10" align="justify">
                <strong className="text-primary">Detalles del Estado de Cuenta</strong>
            </Col>
            <Col md={12} className="custom-mt-10" align="justify">
                Podrás observar el detalle de las transacciones y mediante el botón <button className="btn btn-xs btn-relleno-primary"  style={{borderWidth: 1}}><i className="fa fa-print"></i> Imprimir</button> imprimir el reporte
            </Col>
            <Col md={12} className="custom-mt-10" align="justify">
                En cada transacción puedes ver un ícono ubicado en la parte derecha:
            </Col>
            <Col md={2}className="custom-mt-10"><i className="fa fa-check-circle text-success"></i></Col>
            <Col md={10} align="justify" className="custom-mt-10">
                Indica que la transacción esta aprobada
            </Col>
            <Col md={2} className="custom-mt-10"><i className="fa fa-exclamation-triangle text-warning"></i></Col>
            <Col md={10} align="justify" className="custom-mt-10">
                Indica que la transacción está pendiente por aprobación
            </Col>
            <Col md={2} className="custom-mt-10"><i className="fa fa-times-circle text-danger"></i></Col>
            <Col md={10} align="justify" className="custom-mt-10">
                Este ícono representa un error en la transacción o que la transacción es inválida, en este caso deberás ponerte en contacto con administración
            </Col>
        </Row>
    )

    render() {
        return (
            <div className="content">
                <Row>
                    <Col md={8}>
                        {this.contenido()}
                    </Col>
                    <Col md={4}>
                        <div style={{borderRadius: "4px 4px",}}>
                            <CustomCard
                                styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                category={<span style={{color: "#fff"}}>Estados de Cuenta</span>}
                                color="#a80012"
                                content={this.ayuda()}
                            />
                        </div>
                    </Col>
                </Row>
                {this.modalReporte()}
                {this.modalDel()}
                {this.modalEdit()}
                {this.modalConfirm()}
                {this.modalConfirm2()}
            </div>
        );
    }
}
 
export default Cuentas;


// WEBPACK FOOTER //
// ./src/views/Administracion/EstadosCuentaContent/Cuentas.jsx